export default __webpack_public_path__ + "static/media/vampire_cards.5be01a13.png";